import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "co-price"
}
const _hoisted_2 = {
  key: 0,
  class: "co-price__amount co-price__amount--compact"
}
const _hoisted_3 = {
  key: 0,
  class: "salePrice"
}
const _hoisted_4 = {
  key: 1,
  class: "co-price__amount"
}
const _hoisted_5 = {
  key: 0,
  class: "salePrice"
}
const _hoisted_6 = {
  key: 2,
  class: "co-price__vat"
}

import { computed } from 'vue';
import { PriceViewModel } from '../../@types/generated/PriceViewModel';

import { useShopStore } from '../../stores/shopStore';
import { useSiteStore } from '../../stores/siteStore';
type Props = {
  price: PriceViewModel;
  compact?: boolean;
  vat?: boolean;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'PriceObject',
  props: {
    price: {},
    compact: { type: Boolean },
    vat: { type: Boolean }
  },
  setup(__props: any) {

const shopStore = useShopStore();

const siteStore = useSiteStore();

const props = __props;

const salePrice = computed(() => {
  if (!shopStore.showVat) {
    return props.price.salePriceExclVat;
  }
  return props.price.salePriceInclVat;
});

const price = computed(() => {
  if (!shopStore.showVat) {
    return props.price.priceExclVat;
  }
  return props.price.priceInclVat;
});

const label = computed(() => {
  if (!shopStore.showVat) {
    return 'ekskl. moms';
  }
  return 'inkl. moms';
});

const showPrice = computed(() => {
  if (!siteStore.account.hasCommerceAccess) {
    return false;
  }

  if (!props.price.hasPrice) {
    return false;
  }

  return true;
});

return (_ctx: any,_cache: any) => {
  return (showPrice.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (props.compact)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (props.price.onSale)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(salePrice.value), 1))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(["price", { 'price--free': props.price.isFree }])
                  }, _toDisplayString(price.value), 3))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (props.price.onSale)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(salePrice.value), 1))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: _normalizeClass(["price", [
          { 'price--sale': props.price.onSale },
          { 'price--free': props.price.isFree },
        ]])
              }, _toDisplayString(price.value), 3)
            ])),
        (props.vat)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(label.value), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})